export default "__VITE_ASSET__BIFyj8wq__"